import React from "react";
import { Dropdown } from "semantic-ui-react";
import { IcList, CardList } from "ceicons";
import { useTranslation } from "ceco-polyglot";

import "./togglerHeader.scss";
const TogglerHeader = ({
  setOrderBy,
  hasCardMode = true,
  cardMode,
  setCardMode,
  newOptions,
}) => {
  const t = useTranslation();
  const options = newOptions
    ? newOptions
    : [
        {
          key: "published",
          text: t("filter.publication"),
          value: "published",
        },
        {
          key: "category",
          text: t("filter.category"),
          value: "category",
        },
      ];

  return (
    <div className="toggler-header">
      <div className="left">
        <span>
          {t("filter.order-by")}{" "}
          <Dropdown
            inline
            options={options}
            onChange={(e, { value }) => {
              setOrderBy(value);
            }}
            defaultValue={options[0].value}
          />
        </span>
      </div>
      {hasCardMode && (
        <div className="right">
          <IcList
            className={!cardMode ? "active" : undefined}
            onClick={() => {
              setCardMode(false);
            }}
          />

          <CardList
            className={cardMode ? "active" : undefined}
            onClick={() => {
              setCardMode(true);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TogglerHeader;
